var _rect, _rect2, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.491,
    y: 0.203,
    width: 65.509,
    height: 65.509,
    rx: 10.642,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.812,
    y: 5.523,
    width: 54.867,
    height: 54.867,
    rx: 13.302,
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--gradient-stop)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.856 20.666c0 5.607-4.407 10.154-9.843 10.154-5.437 0-9.844-4.547-9.844-10.154 0-5.608 4.407-10.154 9.844-10.154 5.436 0 9.843 4.546 9.843 10.154zM15.787 43.951c0-5.608 4.407-10.154 9.843-10.154h14.765c5.436 0 9.843 4.546 9.843 10.154s-4.407 10.154-9.843 10.154H25.63c-5.436 0-9.843-4.546-9.843-10.154z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.22bed46465089dbe31b9299d512b3db9.svg";
export { ForwardRef as ReactComponent };